const cards = [
  {
    title: '探花精选 · 月度合集',
    desc: '本月最受欢迎的探花精选内容汇总，涵盖多类型资源，一站式满足您的浏览需求。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20amber%20and%20soft%20golden%20abstract%20composition%20with%20flowing%20elegant%20shapes%2C%20rich%20textured%20background%20with%20subtle%20light%20gradients%2C%20refined%20artistic%20photography%20style%2C%20luxurious%20warm%20atmosphere%2C%20sophisticated%20color%20palette%20of%20gold%20and%20crimson%2C%20no%20text%2C%20no%20people%2C%20abstract%20art&width=800&height=560&seq=card-tanhua-monthly&orientation=landscape',
    tag: '热门',
  },
  {
    title: '经典回顾 · 探花珍藏',
    desc: '精选历年探花在线经典内容，值得反复回味的珍品合集，探花老用户必看。',
    img: 'https://readdy.ai/api/search-image?query=Deep%20rich%20burgundy%20and%20gold%20abstract%20background%20with%20soft%20silk%20texture%20patterns%2C%20elegant%20dramatic%20lighting%20with%20shadow%20depths%2C%20vintage%20refined%20aesthetic%2C%20warm%20atmospheric%20tones%2C%20luxurious%20fabric%20folds%2C%20no%20text%2C%20no%20people%2C%20fine%20art%20photography&width=800&height=560&seq=card-tanhua-classic&orientation=landscape',
    tag: '经典',
  },
  {
    title: '最新上架 · 探花新品',
    desc: '探花在线每日更新的最新内容，第一时间获取探花新地址上的新增资源。',
    img: 'https://readdy.ai/api/search-image?query=Fresh%20warm%20coral%20and%20soft%20golden%20abstract%20art%20with%20flowing%20organic%20curves%2C%20gentle%20gradients%20from%20rose%20to%20amber%2C%20clean%20modern%20aesthetic%2C%20soft%20natural%20light%20diffusion%2C%20elegant%20minimal%20composition%2C%20no%20text%2C%20no%20people%2C%20abstract%20style&width=800&height=560&seq=card-tanhua-new&orientation=landscape',
    tag: '新品',
  },
  {
    title: '稀有珍藏 · 探花特辑',
    desc: '探花资源中难得一见的稀有内容合集，精心整理供探花爱好者收藏。',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20dark%20amber%20and%20deep%20crimson%20abstract%20composition%2C%20dramatic%20contrast%20with%20golden%20sparkle%20accents%2C%20rich%20velvet%20textures%2C%20luxurious%20premium%20atmosphere%2C%20scattered%20light%20particles%20like%20golden%20dust%2C%20no%20text%2C%20no%20people%2C%20fine%20art&width=800&height=560&seq=card-tanhua-rare&orientation=landscape',
    tag: '稀有',
  },
  {
    title: '高人气的 · 探花周榜',
    desc: '探花用户投票选出的每周人气最高的探花精选内容，热门风向早知道。',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20warm%20rose%20gold%20and%20amber%20abstract%20flowing%20waves%2C%20energetic%20yet%20elegant%20artistic%20composition%2C%20dynamic%20light%20streaks%20with%20soft%20focus%2C%20modern%20trendy%20aesthetic%2C%20luxurious%20warm%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20abstract%20art&width=800&height=560&seq=card-tanhua-popular&orientation=landscape',
    tag: '人气',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="scroll-mt-16 py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
            精选推荐
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {cards.slice(0, 3).map((card) => (
              <a
                key={card.title}
                href="#cards"
                onClick={(e) => e.preventDefault()}
                className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer group"
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <span className="absolute top-3 left-3 px-2 py-0.5 text-[10px] font-bold text-white bg-accent-500/90 rounded-full whitespace-nowrap">{card.tag}</span>
                </div>
                <div className="p-4">
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">{card.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{card.desc}</p>
                </div>
              </a>
            ))}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
            {cards.slice(3, 5).map((card) => (
              <a
                key={card.title}
                href="#cards"
                onClick={(e) => e.preventDefault()}
                className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer group flex flex-col sm:flex-row"
              >
                <div className="relative w-full sm:w-[200px] aspect-[4/3] sm:aspect-auto overflow-hidden flex-shrink-0">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <span className="absolute top-3 left-3 px-2 py-0.5 text-[10px] font-bold text-white bg-accent-500/90 rounded-full whitespace-nowrap">{card.tag}</span>
                </div>
                <div className="p-4 flex flex-col justify-center">
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">{card.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{card.desc}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}